module.exports = {"451222100":"六排镇","451222101":"向阳镇","451222200":"岜暮乡","451222201":"八腊瑶族乡","451222203":"纳直乡","451222204":"更新乡","451222206":"下老乡","451222207":"坡结乡","451222208":"三堡乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/451222.json
// module id = 2161
// module chunks = 0